import { assertUnreachable } from "../helpers";
import { MaterialGradeSchema, MaterialGradeType } from "../types";

type Params = { materialGrade: MaterialGradeType | null };

/**
 *
 * @returns the density of the materialGrade in kg/dm3 or g/cm3
 */
export const getMaterialDensity = ({ materialGrade }: Params): number => {
  if (!materialGrade) {
    return 0;
  }

  switch (materialGrade) {
    case MaterialGradeSchema.enum.ALUMINIUM:
      return 2.7;
    case MaterialGradeSchema.enum.BRASS:
      return 8.73;
    case MaterialGradeSchema.enum.COPPER:
      return 8.96;
    case MaterialGradeSchema.enum.GALVANIZED_STEEL:
      return 7.8;
    case MaterialGradeSchema.enum.STAINLESS_STEEL:
      return 7.8;
    case MaterialGradeSchema.enum.STEEL:
      return 7.85;
    case MaterialGradeSchema.enum.STEEL_PRE_LACQUERED:
      return 7.85;
    case MaterialGradeSchema.enum.STEEL_COLD_ROLLED_CORTEN:
      return 7.85;
    case MaterialGradeSchema.enum.STEEL_HOT_ROLLED_CORTEN:
      return 7.85;
    case MaterialGradeSchema.enum.ZINC:
      return 7.13;
    case MaterialGradeSchema.enum.BRONZE:
      return 8.73;
    case MaterialGradeSchema.enum.CAST_IRON:
      return 7.87;
    case MaterialGradeSchema.enum.RUBBER:
      return 0.93;
    case MaterialGradeSchema.enum.MAGNESIUM:
      return 1.738;
    case MaterialGradeSchema.enum.TITANIUM:
      return 4.5;
    case MaterialGradeSchema.enum.PLASTIC:
      return 1.2;
    case MaterialGradeSchema.enum.COMPOSITE:
      return 1.6;
    case MaterialGradeSchema.enum.WOOD:
      return 0.6;
    case MaterialGradeSchema.enum.INCONEL:
      return 8.44;
    case MaterialGradeSchema.enum.OTHER:
      return 0;
    default:
      assertUnreachable(materialGrade);
  }
};
